export default "__VITE_ASSET__CioCR0gs__"